export default "__VITE_ASSET__CV1WqVfx__"